
import { Fragment } from "react";
import {
  Popover as HeadlessPopover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from "@headlessui/react";
import clsx from "clsx";

export interface PopoverProps {
  trigger: React.ReactNode;
  children: React.ReactNode;
  align?: "left" | "center" | "right";
  className?: string;
  panelClassName?: string;
}

export function Popover({
  trigger,
  children,
  align = "center",
  className,
  panelClassName,
}: PopoverProps) {
  const alignClasses = {
    left: "left-0",
    center: "left-1/2 -translate-x-1/2",
    right: "right-0",
  };

  return (
    <HeadlessPopover className={clsx("relative", className)}>
      <PopoverButton as={Fragment}>{trigger}</PopoverButton>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <PopoverPanel
          className={clsx(
            "absolute z-50 mt-2 w-max rounded-lg bg-surface border border-neutral-subtle shadow-lg",
            alignClasses[align],
            panelClassName
          )}
        >
          {children}
        </PopoverPanel>
      </Transition>
    </HeadlessPopover>
  );
}

export default Popover;
